    <div class="container-fluid p-0">
        <nav class="navbar navbar-light bg-light p-0">
            <div class="container-fluid bg-white p-3">
                <img src="assets/brand/orange-logo.svg" width="35" height="35" role="img" alt="Boosted" loading="lazy">
            </div>
          </nav>
    </div>
    <div class="container-fluid gx-0 containerFluid">
        <div class="row gx-0 rowOfMedia">
            <div
                class="col-12 col-sm-12 col-md-12 col-lg-6 
                       blocImg d-flex bg-white justify-content-center align-items-center imgBg">
                <img src="assets/images/logo-mabox.jpg" height="180px" alt="">
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 blocAction blocActionSple" style="margin-top: 40px;">
                <div class="row mx-auto">
                    <div class="col-12 text-center mb-2">
                        <span style="font-size: 1.3em;">Téléchargez</span><br>
                        <span style="color: #FF7900 !important;font-size: 2em;" class="fw-bold">Ma Box orange </span> 
                    </div>
                    <!-- <div class="col-12 fw-bold text-center"> -->
                         <!-- <i class='bx bx-down-arrow-alt'
                            style="font-size: 18px;position: relative;top: 3px;"></i> -->
                    <!-- </div> -->
                    <div class="row justify-content-center g-2">
                        <div class="col-10 mt-0 bg-white" (click)="goPlay()"
                            style="border: 1px solid #cfcfcf; border-radius: 5px;">
                            <div class="d-flex justify-content-center align-items-center  p-2 ">
                                <img src="assets/images/image46.png" alt="">
                                <span class="ms-2">Google play </span>
                            </div>

                        </div>
                        <div class="col-10 bg-white" (click)="goApple()"
                            style="border: 1px solid #cfcfcf;border-radius: 5px;">
                            <div class="d-flex justify-content-center align-items-center  p-2 ">
                                <img src="assets/images/image47.png" alt="">
                                <span class="ms-2">Apple store</span>
                            </div>
                        </div>
                        <!-- <div class="col-10 bg-white" (click)="goAppGallery()"
                            style="border: 1px solid #cfcfcf;border-radius: 5px;">
                            <div class="d-flex justify-content-center align-items-center p-2">
                                <img src="assets/images/image49H.png" alt="">
                                <span class="ms-2">AppGallery</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
<!-- </div> -->